import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/vant.js'

import axios from 'axios'
Vue.prototype.$https = axios
axios.defaults.baseURL = 'https://api.nm.caichangyun.com/'

Vue.config.productionTip = false

// px2rem 自适应
import 'lib-flexible'
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
